"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("@tanstack/react-query");
var _axios = _interopRequireDefault(require("axios"));
var _Link = _interopRequireDefault(require("../Link"));
var _analytics = require("../analytics");
var _jsxRuntime = require("react/jsx-runtime");
const COLLISION_CENTER_URL = "/rest/lexus/collision-centers";
const collisionCenterService = {
  fetch: async function (dealerCode) {
    if (!dealerCode) {
      return null;
    }
    const {
      data
    } = await _axios.default.get(COLLISION_CENTER_URL, {
      params: {
        dealerCode
      }
    });
    return data;
  }
};
const useCollisionCenter = function (dealerCode) {
  return (0, _reactQuery.useQuery)(["collisionCenter", dealerCode], function () {
    return collisionCenterService.fetch(dealerCode);
  });
};
const CollisionCenterLink = function (_ref) {
  var _data$collisionCenter, _data$collisionCenter2;
  let {
    dealerCode,
    handleCloseEvent,
    children
  } = _ref;
  const {
    data,
    isLoading,
    error
  } = useCollisionCenter(dealerCode);
  const withIntsrcSearchParams = (0, _analytics.useAnalyticsQueryParam)({
    intsrc: "{brand}:{section}:{action}:{destination}"
  });
  if (isLoading || error || !data) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  const url = data === null || data === void 0 ? void 0 : (_data$collisionCenter = data.collisionCenters) === null || _data$collisionCenter === void 0 ? void 0 : (_data$collisionCenter2 = _data$collisionCenter.flatMap(function (center) {
    var _center$contact, _center$contact$urls;
    return (center === null || center === void 0 ? void 0 : (_center$contact = center.contact) === null || _center$contact === void 0 ? void 0 : (_center$contact$urls = _center$contact.urls) === null || _center$contact$urls === void 0 ? void 0 : _center$contact$urls.map(function (u) {
      return u === null || u === void 0 ? void 0 : u.url;
    })) || [];
  })) === null || _data$collisionCenter2 === void 0 ? void 0 : _data$collisionCenter2.find(function (url) {
    return url != null;
  });
  if (!url) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
    href: withIntsrcSearchParams(url, {
      destination: "collision-center"
    }),
    onClick: handleCloseEvent,
    "data-testid": "CollisionCenterLink",
    children: children || dealerCode
  });
};
var _default = exports.default = CollisionCenterLink;